import type { RootState } from './app';

export const HYDRATE_STATE = 'HYDRATE_STATE';
export type HYDRATE_ACTION = {
    type: typeof HYDRATE_STATE;
    data: Partial<RootState>;
};
